import { parseISO } from 'shared/util/datetime-fns';

export const formatDateRange = (
    fromDate: string | null | undefined,
    toDate: string | null | undefined,
    format: (date: Date | number) => string,
) => {
    if (!fromDate || !toDate) return 'Når som helst';
    return `${format(parseISO(fromDate))} - ${format(parseISO(toDate))}`;
};

export const formatGuestText = (beds: number | string | null | undefined) => {
    const bedsNum = Number(beds ?? 0);
    if (bedsNum === 0) return 'Alle gjester';
    if (bedsNum === 1) return '1 gjest';
    return `${bedsNum} gjester`;
};

export const formatLocationText = (city?: string | null, country?: string | null) => {
    if (city && country) return `${city}, ${country}`;
    if (city) return city;
    if (country) return country;
    return 'Hvor som helst';
};

export const formatBedroomText = (bedrooms: number | string | null | undefined) => {
    const bedroomsNum = Number(bedrooms ?? 0);
    if (bedroomsNum === 0) return 'Alle soverom';
    if (bedroomsNum === 1) return '1 soverom';
    return `${bedroomsNum} soverom`;
};
